import React from 'react';
import PropTypes from 'prop-types'; 
import AuthContextProvider from './AuthContext'; 
import MealContextProvider from './MealContext';
import RestaurantContextProvider from './RestaurantContext';
import GlobalVarContextProvider from './GlobalVarContext';
import PermissionContextProvider from './PermissionContext';
import Bookingcontextprovider from './Bookingcontext';
import Dashboard from '../containers/Restau/Dashboard/Dashboard';
import DashboardContextProvider from './DashboardContext';
import SideBarRefreshContextProvider from './SideBarRefreshContext';

const AppContextProvider = ({ children }) => (
  <SideBarRefreshContextProvider>
    <DashboardContextProvider> 
      <GlobalVarContextProvider>
        <PermissionContextProvider>
          <AuthContextProvider>
            <MealContextProvider>
              <RestaurantContextProvider>
                <Bookingcontextprovider>
                  {children}
                </Bookingcontextprovider>
              </RestaurantContextProvider>
            </MealContextProvider>
          </AuthContextProvider>
        </PermissionContextProvider>
      </GlobalVarContextProvider>
    </DashboardContextProvider>
  </SideBarRefreshContextProvider>
 
  
  );

AppContextProvider.propTypes = {
  children: PropTypes.node.isRequired, 
};

export default AppContextProvider;
